import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const PAGES_ID = [1, 2, 3, 4]
const VIEW_PAGES = [1, 2, 3]

/**
 *  Pop up showed when you have finished the game
 */
class VoteQuestion extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      vote: null,
    }

    this.pages = {
      page1: () => this.renderPage1(),
      page2: () => this.renderPage2(),
      page3: () => this.renderPage3(),
      page4: () => this.renderPage4(),
    }
  }

  componentWillUnmount() {
    const { clearResponses } = this.props
    clearResponses()
  }

  voteQuestion(e) {
    const { currentQuestion, voteQuestion, addHowlSound } = this.props
    const { vote } = this.state
    const elements = this.form
    const explanation = elements['explanation'].value
    addHowlSound('button_click')

    e.preventDefault()
    e.stopPropagation()

    vote && explanation
      ? voteQuestion({ ...currentQuestion, vote: vote, explanation: explanation })
      : null
  }

  renderPage4() {
    const { intl, changeMiningScreen, addHowlSound } = this.props
    const { vote, hasError } = this.state
    const elements = this.form
    const explanation = elements ? elements['explanation'].value : null
    return (
      <form ref={(form) => (this.form = form)} className="mina--questions">
        <div className="mina--buttons">
          <div
            onClick={() => {
              this.setState({ vote: 'voteInvalid' })
              addHowlSound('button_click')
            }}
            className={`mina--button__form ${vote == 'voteInvalid' ? 'failed' : ''}`}
          >
            <FormattedMessage id="questions.wrong" />
          </div>
          <div
            onClick={() => {
              this.setState({ vote: 'voteValid' })
              addHowlSound('button_click')
            }}
            className={`mina--button__form ${vote == 'voteValid' ? 'success' : ''}`}
          >
            <FormattedMessage id="questions.correct" />
          </div>
        </div>
        <textarea
          ref={this.explanation}
          placeholder={intl.formatMessage({ id: 'questions.opinion' })}
          name="explanation"
          id="explanation"
          className={`mina--textarea ${hasError && !explanation ? 'failed' : ''}`}
        ></textarea>
        {hasError && !explanation && (
          <div className="alert--error shake-animation">
            <FormattedMessage id="questions.debate.alert" />
          </div>
        )}
        <div className="mina--buttons">
          <div
            onClick={(e) => {
              if (!explanation || !vote) this.setState({ hasError: true })
              this.voteQuestion(e)
            }}
            className={`btn--shape shape--orange`}
          >
            <div className="btn--shape__canvas">
              <FormattedMessage id="questions.accept" />
            </div>
          </div>
          <div
            onClick={() => {
              changeMiningScreen('mining_default')
              addHowlSound('button_click')
            }}
            className="btn--shape shape--orange"
          >
            <div className="btn--shape__canvas">
              <FormattedMessage id="questions.cancel" />
            </div>
          </div>
        </div>
      </form>
    )
  }

  renderDebateText(debate) {
    if (debate && debate.variables !== undefined && debate.variables !== null) {
      return (
        <div>
          <FormattedMessage id={debate.debateText} />
          {debate.variables}
        </div>
      )
    } else {
      return <span>{debate.debateText}</span>
    }
  }
  renderPage3() {
    const { currentQuestion, playerList } = this.props
    return (
      <div className="mina--discussion scroll">
        {currentQuestion.dispute.debate.map((a, index) => (
          <div key={index} className="mina--discussion__item">
            <span className="title">
              {index == 0 || !a.authorLicenseId
                ? '???'
                : playerList[a.authorLicenseId] && playerList[a.authorLicenseId].colonyName
                ? playerList[a.authorLicenseId].colonyName
                : a.authorLicenseId}
            </span>
            <span>{this.renderDebateText(a)}</span>
          </div>
        ))}
      </div>
    )
  }

  renderPage1() {
    const { currentQuestion } = this.props
    return (
      <div className="mina--discussion">
        <div className="mina--discussion__question">
          <div className="mina--discussion__title">
            <FormattedMessage id="questions.question" />
          </div>
          <div className="mina--discussion__subtitle">{currentQuestion.question}</div>
        </div>
        <div className="mina--discussion__reason">
          <div className="mina--discussion__title">
            <FormattedMessage id={`questions.cause`} />
            <span className="color--orange padding--left ">
              <FormattedMessage id={`questions.${currentQuestion.dispute.cause.toLowerCase()}`} />
            </span>
          </div>
          <p>
            {currentQuestion.dispute.debate[0] && currentQuestion.dispute.debate[0].debateText
              ? currentQuestion.dispute.debate[0].debateText
              : null}
          </p>
        </div>
      </div>
    )
  }

  renderPage2() {
    const { currentQuestion } = this.props
    const answers = currentQuestion.choices

    return (
      <div className="mina--discussion">
        <div className="mina--discussion__question">
          <div className="mina--discussion__title">
            <FormattedMessage id="questions.question" />
          </div>
          <div className="mina--discussion__subtitle">{currentQuestion.question}</div>
        </div>
        <div className="mina--discussion__reason">
          <div className="mina--discussion__title">
            <FormattedMessage id="questions.answers" />
          </div>
          {answers.map((a) => (
            <div
              key={a.text}
              className={`mina--discussion__response ${a.isCorrect ? 'success' : ''}`}
            >
              {a.text} {a.isCorrect ? <span className="icon-doing"> </span> : null}
            </div>
          ))}
        </div>
      </div>
    )
  }

  render() {
    const { currentQuestion, changeMiningScreen, error, addHowlSound } = this.props
    const { page } = this.state
    const renderPage = this.pages[`page${page}`]

    if (error && error == 'no_dispute_question')
      return (
        <div className="mina--layer vertical--center growIn-animation">
          <div className="position--relative">
            <FormattedMessage id="questions.no_debates" />
            <div className="mina--buttons">
              <div
                className="btn--shape shape--orange"
                onClick={() => {
                  changeMiningScreen('mining_default')
                  addHowlSound('button_click')
                }}
              >
                <div className="btn--shape__canvas">
                  <FormattedMessage id="questions.back" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    if (!currentQuestion) {
      return (
        <div className="mina--layer">
          <FormattedMessage id="questions.loading" />
        </div>
      )
    }
    const pages = currentQuestion.onlyView ? VIEW_PAGES : PAGES_ID

    return (
      <div className="mina--layer growIn-animation">
        <div className="mina--message">
          <div>
            <FormattedMessage id={`questions.debate.title${page}`} />
          </div>
        </div>
        {page == 4 && (
          <div className="mina--subtitle">
            <FormattedMessage id={`questions.debate.disputeSubtitle`} />
          </div>
        )}

        {renderPage()}
        <div className="mina--paginator">
          <div className="mina--paginator__pages">
            {page > 1 ? (
              <span
                className="icon-arrow-left"
                onClick={() => (page > 1 ? this.setState({ page: page - 1 }) : null)}
              />
            ) : null}
            {pages.map((p) => (
              <span
                onClick={() => {
                  this.setState({ page: p })
                  addHowlSound('button_click_icon')
                }}
                key={p}
                className={page == p ? 'bullet active' : 'bullet'}
              ></span>
            ))}
            {page < pages.length ? (
              <span
                className="icon-arrow-right"
                onClick={() => {
                  page < pages.length ? this.setState({ page: page + 1 }) : null
                  addHowlSound('button_click_icon')
                }}
              />
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}
VoteQuestion.propTypes = {
  changeMiningScreen: PropTypes.func,
  voteQuestion: PropTypes.func,
  clearResponses: PropTypes.func,
  currentQuestion: PropTypes.object,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]),
  addHowlSound: PropTypes.func,
  playerList: PropTypes.object,
}

export default VoteQuestion
